import { Typography } from '@material-ui/core';
import ReactHookTextField from 'components/ReactHookTextField';
import SelectWithDataReactHook from 'components/SelectWithDataReactHook';
import { colourOptions, finishOptions } from 'constants/finishing';

const BeltGuard = ({ control, tableView }) => {
    return (
        <>
            {!tableView ? <Typography variant="h6" gutterBottom>Belt Guard</Typography> : <br/>}
            <ReactHookTextField
                name='attributes.driveBeltGuardQty'
                type='text'
                control={control}
                label='Qty'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.driveBeltGuardCentreRange'
                type='text'
                control={control}
                label='Centre Range'
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.driveBeltGuardMaterial'
                type='text'
                control={control}
                label='Material'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.driveBeltGuardPaint'
                control={control}
                label='Paint'
                creatable={true}
                options={colourOptions}
                style={{width: '19%', marginRight: '1%'}}
            />
            <ReactHookTextField
                name='attributes.driveBeltGuardNotes'
                type='text'
                control={control}
                label='Notes'
                style={{width: '19%', marginRight: '1%'}}
            />
            <SelectWithDataReactHook
                name='attributes.driveBeltGuardFinish'
                control={control}
                label='Finish'
                options={finishOptions}
                style={{width: '14%', marginRight: '1%'}}
            />
        </>   
    );
};

export default BeltGuard;
